import React from 'react'
import PropTypes from 'prop-types'
import {
  Map as ImmutableMap,
  List as ImmutableList,
} from 'immutable'
import { connect } from 'react-redux'
import { expandMarketplaceListingsByBusiness, fetchBusinessById, updateBusinessCoupons, updateBusinessHours } from '../actions/businesses'
import Image from '../components/image'
import Text from '../components/text'
import Button from '../components/button'
import { BREAKPOINT_EXTRA_SMALL, CX, DEFAULT_REL, MODAL_COUPONS, MODAL_HOURS, MODAL_PRO_UPGRADE, POPOVER_BUSINESS_OPTIONS, POPOVER_SHARE } from '../constants'
import { isStaff, me, meBusinesses } from '../initial_state'
import BusinessStatusTag from '../components/business/business_status_tag'
import Icon from '../components/icon'
import { addShortcut, removeShortcut } from '../actions/shortcuts'
import ColumnIndicator from '../components/column_indicator'
import { NavLink } from 'react-router-dom'
import Avatar from '../components/avatar'
import DisplayName from '../components/display_name'
import VerifiedBusinessIcon from '../components/verified_business_icon'
import { openModal } from '../actions/modal'
import BusinessMarketplaceListings from './business_marketplace_listings'
import moment from 'moment-mini'
import { openPopover } from '../actions/popover'
import TabBar from '../components/tab_bar'
import GlobalFooter from '../components/global_footer'
import PanelLayout from '../components/panel/panel_layout'
import ProfileInfoPanel from '../components/panel/profile_info_panel'
import Map from '../components/map'
import BusinessCoupon from '../components/business/business_coupon'
import { shortNumberFormat } from '../utils/numbers'

class Business extends React.PureComponent {

  state = {
    scrolledTo: 'about'
  }

  componentDidMount() {
    const { businessId, onFetchBusinessById, onExpandMarketplaceListingsByBusiness } = this.props
    onFetchBusinessById(businessId)
    onExpandMarketplaceListingsByBusiness(businessId)
  }

  componentDidUpdate(prevProps) {
    const { businessId, business, onFetchBusinessById } = this.props
    if (prevProps.businessId !== businessId && !business) {
      onFetchBusinessById(businessId)
    }
  }

  handleOnOpenProModal = () => {
    this.props.onOpenProModal(this.props.businessId)
  }

  handleOnShare = () => {
    this.props.onOpenSharePopover(this.shareNode, this.props.business)
  }

  handleOnOpenOptions = () => {
    this.props.onOpenOptionsPopover(this.optionsNode, this.props.business)
  }

  handleOnToggleShortcut = () => {
    const { onRemoveShortcut, onAddShortcut, isShortcut, businessId } = this.props
    if (isShortcut) {
      onRemoveShortcut(businessId)
    } else {
      onAddShortcut(businessId)
    }
  }

  handleOnScrollTo = (tab) => {
    this.setState({ scrolledTo: tab })
    const section = document.getElementById(tab)
    // if (section) {
    //   section.scrollIntoView({ behavior: 'smooth' })
    // }
    if (section) {
      const offset = 120 // Offset value
      const sectionPosition = section.getBoundingClientRect().top + window.pageYOffset - offset

      window.scrollTo({
        top: sectionPosition,
        behavior: 'smooth'
      })
    }
  }

  setShareNode = (c) => {
    this.shareNode = c
  }

  setOptionsNode = (c) => {
    this.optionsNode = c
  }

  render() {
    const {
      title,
      business,
      businessId,
      isShortcut,
      isOwner,
      isXS,
      account,
      businessAccount,
      hasListingIds,
    } = this.props
    const { scrolledTo } = this.state

    if (!business) {
      return <ColumnIndicator type='loading' />
    }

    // console.log("isOwner:", businessAccount, isOwner)

    const hasCTA = business.getIn(['cta', 'title'], '') && business.getIn(['cta', 'link'], '')
    const hasCategories = business.get('categories') && business.get('categories').size > 0
    const websites = business.get('websites')

    const innerHeaderClasses = CX({
      d: 1,
      w1255PX: 1,
      mlAuto: 1,
      mrAuto: 1,
      // pb10: 1,
      px10: isXS,
    })

    const containerClasses = CX({
      d: 1,
      w100PC: 1,
      // border1PX: !isXS,
      borderBottom1PX: isXS,
      radiusSmall: !isXS,
      // borderColorSecondary: 1,
      // bgPrimary: 1,
      // boxShadowBlock: 1,
      mt10: 1,
    })

    const hoursClasses = CX({
      d: 1,
      w100PC: 1,
      flexRow: 1,
      mb2: !isXS,
      mb10: isXS,
    })

    const headerInfoClasses = CX({
      d: 1,
      ml15: 1,
      mt2: !isXS,
      flexRow: !isXS,
      flex1: 1,
    })

    const headerInfoBtnClasses = CX({
      w100PC: isXS,
      mt15: isXS,
    })

    const hours = !!business.get('hours') ? business.get('hours').toJS() : null
    const hasLocations = !!business.get('locations') && ImmutableMap.isMap(business.get('locations'))

    const is247 = !hours || (Array.isArray(hours) && hours.length === 1)
    const expirationDate = !!business.get('pro_expires_at') ? moment(business.get('pro_expires_at')).format('MM-DD-YYYY') : '-'

    const viewCount = isOwner && business ? business.getIn(['analytics', 0, 'count'], 0) : 0
		const viewsLabel = viewCount === 1 ? 'view' : 'views'

    const information = (
      <>
        {/* <Text size='small' className={[_s.mt2].join(' ')}>{business.get('tagline')}</Text> */}
        <div className={[_s.d, _s.pt10, _s.flexRow, _s.flexWrap].join(' ')}>
          {
            !!me &&
            <Button
              radiusSmall
              backgroundColor='tertiary'
              color='primary'
              icon={isShortcut ? 'star' : 'star-outline'}
              iconSize={isXS ? '16px' : '18px'}
              className={[_s.jcCenter, _s.aiCenter, _s.mr10, _s.px10, _s.mb10].join(' ')}
              onClick={this.handleOnToggleShortcut}
            />
          }
          <Button
            radiusSmall
            backgroundColor='tertiary'
            color='primary'
            icon='share'
            iconSize={isXS ? '16px' : '18px'}
            buttonRef={this.setShareNode}
            className={[_s.jcCenter, _s.aiCenter, _s.mr10, _s.px10, _s.mb10].join(' ')}
            onClick={this.handleOnShare}
          />
          {
            isStaff &&
            <Button
              radiusSmall
              backgroundColor='tertiary'
              color='primary'
              icon='ellipsis'
              iconSize={isXS ? '16px' : '18px'}
              buttonRef={this.setOptionsNode}
              className={[_s.jcCenter, _s.aiCenter, _s.mr10, _s.px10, _s.mb10].join(' ')}
              onClick={this.handleOnOpenOptions}
            />
          }
        </div>
      </>
    )

    const sidebarInfoTitle = isXS ? (
      <span className={[_s.d, _s.pl10].join(' ')}>
        Information
      </span>
    ) : 'Information'
          
    const sidebar = (
      <div className={isXS ? [_s.d, _s.w100PC, _s.py15].join(' ') : [_s.d, _s.ml15, _s.w380PX, _s.py15].join(' ')}>
        <PanelLayout title={sidebarInfoTitle} noPadding noPanel={isXS}>
          {
            websites && websites.size > 0 &&
            <div className={[_s.d, _s.mt5, _s.px10].join(' ')}>
              {
                websites.map((websiteUrl, i) => {
                  let match = websiteUrl.match(/^https?:\/\/([^\/]+)/);
                  let hostname = match ? match[1] : null;

                  return (
                    <Button
                      href={websiteUrl}
                      noClasses
                      color='primary'
                      backgroundColor='none'
                      target='_blank'
                      ref={DEFAULT_REL}
                      key={`pill-website-${websiteUrl}`}
                      className={[_s.d, _s.cursorPointer, _s.px5, _s.radiusSmall, _s.aiCenter, _s.bgSubtle_onHover, _s.noUnderline, _s.flexRow, _s.jcCenter, _s.bgTransparent, _s.outlineNone, _s.py5, _s.mb5].join(' ')}
                    >
                      <Text weight='medium' size='large' color='brand'>
                        {hostname}
                      </Text>
                      <div className={[_s.d, _s.radiusSmall, _s.aiCenter, _s.mlAuto, _s.jcCenter, _s.h30PX, _s.w30PX].join(' ')}>
                        <Icon id='arrow-right' className={[_s.cBrand].join(' ')} />
                      </div>
                    </Button>
                  )
                })
              }
            </div>
          }

          {
            business.get('phone_number') &&
            <div className={[_s.d, _s.px10].join(' ')}>
              <a href={`tel:${business.get('phone_number')}`} className={[_s.d, _s.cursorPointer, _s.px5, _s.radiusSmall, _s.aiCenter, _s.bgSubtle_onHover, _s.noUnderline, _s.w100PC, _s.flexRow, _s.jcCenter, _s.bgTransparent, _s.outlineNone, _s.py10, _s.mb5].join(' ')}>
                <Text size='medium' className={_s.w100PC}>
                  <span className={[_s.d, _s.text, _s.fs16PX, _s.cPrimary, _s.fw500].join(' ')}>Phone:&nbsp;</span>
                  <Text weight='medium' size='large' color='brand'>{business.get('phone_number')}</Text>
                </Text>
              </a>
            </div>
          }

          <div className={[_s.d, _s.mb5, _s.px10].join(' ')}>
            <div className={[_s.d, _s.cursorPointer, _s.px5, _s.radiusSmall, _s.aiCenter, _s.bgSubtle_onHover, _s.noUnderline, _s.w100PC, _s.flexRow, _s.jcCenter, _s.bgTransparent, _s.outlineNone, _s.py10, _s.mb2].join(' ')}>
              <div className={isXS ? [_s.d, _s.w100PC].join(' ') : [_s.d, _s.flexRow, _s.w100PC].join(' ')}>
                <span className={[_s.d, _s.text, _s.fs16PX, _s.cPrimary, _s.fw500, _s.w60PX].join(' ')}>Hours:&nbsp;</span>
                <div className={isXS ? [_s.d, _s.mt10].join(' ') : [_s.d].join(' ')}>
                  {
                    is247 && <Text weight='medium' size='large' color='brand'>Always open</Text>
                  }
                  {
                    !is247 && ['mon', 'tue', 'wed', 'thur', 'fri', 'sat', 'sun'].map((day) => (
                      <div className={hoursClasses} key={`hours-modal-${day}`}>
                        <Text align={'left'} size='large' weight='bold' className={[_s.w60PX, _s.capitalize].join(' ')}>{day}: </Text>
                        <div className={[_s.d, _s.flexRow].join(' ')}>
                          <Text size='large' className={[_s.w84PX, _s.flexRow, _s.aiCenter].join(' ')}>
                            {moment(hours[day].o, "HH:mm").format("h:mm A")}
                          </Text>
                          <Text size='large' className={_s.px5}>to</Text>
                          <Text size='large' className={[_s.w84PX, _s.flexRow, _s.pl5, _s.aiCenter].join(' ')}>
                            {moment(hours[day].c, "HH:mm").format("h:mm A")}
                          </Text>
                        </div>
                      </div>
                    ))
                  }
                </div>
              </div>
            </div>
          </div>
          
          {
            hasLocations &&
            <>
              <div className={[_s.d, _s.mb5, _s.px10].join(' ')}>
                <a
                  href={`https://www.google.com/maps/place/${business.getIn(['locations', 'display_name'])}`}
                  rel={DEFAULT_REL}
                  target='_blank'
                  className={[_s.d, _s.cursorPointer, _s.px5, _s.radiusSmall, _s.aiCenter, _s.bgSubtle_onHover, _s.noUnderline, _s.w100PC, _s.flexRow, _s.jcCenter, _s.bgTransparent, _s.outlineNone, _s.pt5, _s.pb10, _s.mb5].join(' ')}
                >
                  <Text size='medium' className={_s.w100PC}>
                    <span className={[_s.d, _s.text, _s.fs16PX, _s.cPrimary, _s.fw500].join(' ')}>Location:&nbsp;</span>
                      <Text weight='medium' size='large' color='brand'>{business.getIn(['locations', 'display_name'])}</Text>
                  </Text>
                </a>
              </div>
                  
              <div className={[_s.d, _s.h200PX].join(' ')}>
                <Map lat={business.getIn(['locations', 'lat'])} lon={business.getIn(['locations', 'lon'])} />
              </div>
            </>
          }
        </PanelLayout>

        {
          !!business.get('coupons') &&
          <PanelLayout title='Offers' noPadding={!isXS}>
            <div id='offers' className={isXS ? [_s.d, _s.w100PC].join(' ') : [_s.d, _s.w100PC, _s.px10, _s.pt10].join(' ')}>
              {
                !!business.get('coupons') && business.get('coupons').map((coupon, i) => (
                  <BusinessCoupon
                    key={`business-coupon-${i}`}
                    type={coupon.get('type')}
                    amount={coupon.get('amount')}
                    code={coupon.get('code')}
                  />
                ))
              }
            </div>
          </PanelLayout>
        }

        {/* <PanelLayout title='Owner' noPadding>
          <div className={[_s.d, _s.w100PC, _s.px10, _s.pt5].join(' ')}>
            <NavLink
              className={[_s.d, _s.flexRow, _s.cursorPointer,  _s.noUnderline, _s.bgSubtle_onHover, _s.radiusSmall, _s.px5, _s.py10].join(' ')}
              to={`/${account}`}
            >
              <div className={[_s.d, _s.circle, _s.borderColorPrimary].join(' ')}>
                <Avatar account={account} size={40} noHover />
              </div>
              <div className={[_s.d, _s.ml10].join(' ')}>
                <DisplayName account={account} isMultiline noRelationship noHover />
              </div>
            </NavLink>
          </div>
          <div className={[_s.d, _s.w100PC, _s.px15, _s.pt10, _s.pb15].join(' ')}>
              <ProfileInfoPanel noPanel account={account} />
            </div>
        </PanelLayout> */}

        {/* <PanelLayout title='Related Businesses' subtitle='Sponsored'>

        </PanelLayout> */}
          
        <div className={isXS ? [_s.d, _s.w100PC, _s.mt15].join(' ') : [_s.d, _s.w100PC].join(' ')}>
          <Text size='extraLarge' weight='bold' className={[_s.pl15].join(' ')}>More Businesses</Text>
          <div className={[_s.d, _s.mt15, _s.w100PC, _s.flexRow, _s.flexWrap].join(' ')}>
            {
              hasCategories > 0 &&
              <div className={isXS ? [_s.d, _s.flexRow, _s.flexWrap, _s.px10, _s.w100PC].join(' ') : [_s.d, _s.flexRow, _s.flexWrap, _s.w100PC].join(' ')}>
                {
                  business.get('categories').map((c, i) => (
                    <NavLink
                      to={`/businesses/search?category_id=${c.get('id')}`}
                      key={`pill-category-${c.get('id')}`}
                      className={[_s.d, _s.py10, _s.px15, _s.noUnderline, _s.circle, _s.bgSecondary, _s.mr10, _s.mb5].join(' ')}
                    >
                      <Text size='medium' weight='medium'>{c.get('name')}</Text>
                    </NavLink>
                  ))
                }
              </div>
            }
          </div>
        </div>

      </div>
    )

    const hasCover = !!business.get('cover_image_url') && business.get('cover_image_url').indexOf('missing.png') === -1
    
    return (
      <div className={[_s.d, _s.w100PC].join(' ')}>
        <div className={[_s.d, _s.w100PC, _s.bgPrimary].join(' ')}>
          <div className={[_s.d, _s.w100PC, _s.aiCenter].join(' ')}>
            {
              (hasCover || isOwner) &&
              <Image
                src={business.get('cover_image_url')}
                width='100%'
                height={isXS ? 122 : 212}
              />
            }
            {
              isOwner &&
              <div className={[_s.d, _s.w1255PX, _s.mtAuto, _s.z6, _s.posAbs, _s.bottom0, _s.pb15].join(' ')}>
                <Button
                  radiusSmall
                  backgroundColor='tertiary'
                  color='primary'
                  to={`/business/${businessId}/edit`}
                  className={[_s.jcCenter, _s.aiCenter, _s.mlAuto].join(' ')}
                >
                  <Text color='inherit' weight='bold' size='normal' className={_s.px5}>
                    Edit Business
                  </Text>
                </Button>
              </div>
            }
          </div>
          <div className={innerHeaderClasses}>

            <div className={[_s.d, _s.flexRow, _s.pb5, _s.w100PC, _s.pt15].join(' ')}>
              <div className={[_s.d, _s.radiusTiny, _s.borderColorPrimary].join(' ')}>
                <Image
                  src={business.get('logo_thumbnail_url')}
                  width={isXS ? 50 : 106}
                  height={isXS ? 50 : 106}
                  className={[_s.radiusSmall].join(' ')}
                />
              </div>
              <div className={headerInfoClasses}>
                <div className={[_s.d, _s.flexGrow1].join(' ')}>
                  <Text weight='bold' size={isXS ? 'extraLarge' : 'extraExtraLarge'}>
                    {business.get('name')}
                    <VerifiedBusinessIcon className={[_s.ml2, _s.mbNeg2PX].join(' ')} size='24px' proTier={business.get('pro_tier')} />
                  </Text>
                  <Text size='small' className={[_s.mt2].join(' ')}>{business.get('tagline')}</Text>
                  <div className={[_s.d, _s.mt5].join(' ')}>
                    {/*  : todo : */}
                    {
                      isOwner && <BusinessStatusTag id={businessId} />
                    }
                    {
                      isOwner &&
                      <Text color="secondary" className={[_s.jcCenter, _s.aiCenter, _s.mt10].join(' ')}>
                        <Icon id='visible' size='12px' className={_s.cSecondary} />
                        &nbsp;{shortNumberFormat(viewCount)}
                        &nbsp;{viewsLabel}
                      </Text>
                    }
                  </div>
                </div>
                <div className={[_s.d, _s.flexRow, _s.jcEnd, _s.flex1].join(' ')}>
                  <div className={headerInfoBtnClasses}>
                    {
                      hasCTA &&
                      <Button
                        isBlock
                        radiusSmall
                        target='_blank'
                        ref={DEFAULT_REL}
                        href={business.getIn(['cta', 'link'], '')}
                        className={[_s.jcCenter, _s.aiCenter].join(' ')}
                        onClick={this.handleOnEditProfile}
                      >
                        <Text color='inherit' weight='bold' size={isXS ? '' : 'medium'} className={_s.px15}>
                          {business.getIn(['cta', 'title'])}
                        </Text>
                      </Button>
                    }
                    {
                      isXS && information
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>


        <div className={[_s.d, _s.w100PC, _s.flexRow, _s.bgPrimary, _s.borderBottom1PX, _s.borderColorSecondary, _s.boxShadowBlock].join(' ')}>
          <div className={[_s.d, _s.mlAuto, _s.mrAuto, _s.flexRow, _s.aiCenter, _s.jcCenter, _s.w1255PX].join(' ')}>
            <TabBar isLarge tabs={[
              {
                title: 'About',
                active: scrolledTo === 'about',
                onClick: () => this.handleOnScrollTo('about'),
              },
              {
                title: 'Shop',
                active: scrolledTo === 'shop',
                onClick: () => this.handleOnScrollTo('shop'),
              },
              // {
              //   title: 'Gallery',
              // },
              {
                title: 'Offers',
                active: scrolledTo === 'offers',
                onClick: () => this.handleOnScrollTo('offers'),
              },
              // {
              //   title: 'Reviews',
              // },
              // {
              //   title: 'Mentions',
              // },
            ]} />
            {
              !isXS &&
              // : todo : make sticky
              <div className={[_s.d, _s.mlAuto].join(' ')}>
                {information}
              </div>
            }
          </div>
        </div>

        {/*  */}
        <div className={[_s.d, _s.mlAuto, _s.mrAuto, _s.w1255PX, _s.flexRow].join(' ')}>
          <div className={[_s.d, _s.flex1, _s.pt10].join(' ')}>
            {/* about */}
            <div className={[_s.d, _s.w100PC].join(' ')}>
              <div id='about' className={[_s.d, _s.flexRow, _s.aiCenter, _s.mb5, _s.pl15, _s.pr10, _s.pt10].join(' ')}>
                <Text size='extraLarge' weight='bold'>About</Text>
              </div>

              <div className={[_s.d, _s.w100PC, _s.flexRow].join(' ')}>
                <div className={[_s.d, _s.flex1, _s.px15, _s.py15].join(' ')}>
                  <Text size='large'>
                    {business.get('description')}
                  </Text>
                </div>
              </div>
            </div>

            { isXS && sidebar }

            { /*
              (hasListingIds || isOwner) &&
              <div className={[_s.d, _s.w100PC].join(' ')}>
                <div className={[_s.d, _s.flexRow, _s.aiCenter, _s.mb5, _s.pl15, _s.pr10, _s.pt10].join(' ')}>
                  <Text size='extraLarge' weight='bold'>Gallery</Text>
                </div>

                <div className={[_s.d, _s.w100PC, _s.flexRow, _s.py15, _s.px15].join(' ')}>
                  <div
                    style={{
                      display: 'grid',
                      width: '100%',
                      gridTemplateColumns: 'repeat(auto-fit, minmax(calc(100% / 5), 1fr))',
                      gridGap: '10px',
                    }}
                  >
                    {[0,1,2,3].map((i) => (
                      <Image
                        className={_s.radiusSmall}
                        src={business.get('logo_thumbnail_url')}
                      />
                    ))}
                  </div>
                </div>
              </div>
            */ }

            {
              (hasListingIds || isOwner) &&
              <div className={[_s.d, _s.w100PC, _s.mb10].join(' ')}>
                <div className={containerClasses}>
                  <div id='shop' className={[_s.d, _s.flexRow, _s.aiCenter, _s.mb5, _s.pl15, _s.pr10, _s.pb15, _s.pt10].join(' ')}>
                    <Text size='extraLarge' weight='bold'>Shop</Text>
                    {
                      (isOwner && hasListingIds) &&
                      <Button
                        radiusSmall
                        backgroundColor='tertiary'
                        color='primary'
                        to={`/marketplace/dashboard`}
                        className={[_s.jcCenter, _s.aiCenter, _s.mlAuto].join(' ')}
                        onClick={this.handleOnEditProfile}
                      >
                        <Text color='inherit' weight='bold' size='medium' className={_s.px5}>
                          Edit Listings
                        </Text>
                      </Button>
                    }
                    {
                      isOwner &&
                      <Button
                        radiusSmall
                        backgroundColor='tertiary'
                        color='primary'
                        to={`/marketplace/create?business_id=${businessId}`}
                        className={[_s.jcCenter, _s.aiCenter, _s.ml10].join(' ')}
                        onClick={this.handleOnEditProfile}
                      >
                        <Text color='inherit' weight='bold' size='medium' className={_s.px5}>
                          Add Listings
                        </Text>
                      </Button>
                    }
                  </div>
                  <div className={[_s.d, _s.w100PC].join(' ')}>
                    <BusinessMarketplaceListings businessId={businessId} />
                  </div>
                </div>
              </div>
            }
          </div>
        
          {!isXS && sidebar}
          
        </div>

        {!!me && <GlobalFooter />}

      </div>
    )
  }

}

const mapStateToProps = (state, { params: { businessId } }) => {
  const shortcuts = state.getIn(['shortcuts', 'items'])
  const isShortcut = !!shortcuts.find((s) => {
    return s.get('shortcut_id') == businessId && s.get('shortcut_type') === 'business'
  })

  const businessAccount = state.getIn(['businesses', 'business_accounts', businessId])
  const isOwner = !!businessAccount ?
    businessAccount.get('account_id') === me && businessAccount.get('role') === 'owner' : 
    Array.isArray(meBusinesses) && meBusinesses.indexOf(businessId) > -1
  const listingIds = state.getIn(['marketplace_listings_lists', 'business', `${businessId}`, 'items'])
  const hasListingIds = !!listingIds ? listingIds.size > 0 : false

	return {
    isOwner,
    businessAccount,
    isShortcut,
    businessId,
    hasListingIds,
    account: state.getIn(['accounts', me]),
    business: state.getIn(['businesses', 'items', businessId]),
    isXS: state.getIn(['settings', 'window_dimensions', 'width']) <= BREAKPOINT_EXTRA_SMALL,
  }
}

const mapDispatchToProps = (dispatch) => ({
  onAddShortcut(businessId) {
    dispatch(addShortcut('business', businessId))
  },
  onRemoveShortcut(businessId) {
    dispatch(removeShortcut(null, 'business', businessId))
  },
  onFetchBusinessById(businessId) {
    dispatch(fetchBusinessById(businessId))
  },
  onExpandMarketplaceListingsByBusiness(businessId) {
    dispatch(expandMarketplaceListingsByBusiness(businessId))
  },
  onOpenProModal(businessId) {
    dispatch(openModal(MODAL_PRO_UPGRADE, { businessId }))
  },
  onOpenSharePopover(targetRef, business) {
    if (!business) return

    dispatch(openPopover(POPOVER_SHARE, {
      targetRef,
      business,
    }))
  },
  onOpenOptionsPopover(targetRef, business) {
    if (!business) return

    dispatch(openPopover(POPOVER_BUSINESS_OPTIONS, {
      targetRef,
      business,
    }))
  },
})

export default connect(mapStateToProps, mapDispatchToProps)(Business)

